export enum EndpointGraphql {
  WUNDERGRAPH = 'wundergraph',
}
